<template>
  <div class="container mx-auto">
    <CRow>
      <CCol xs="12" sm="12" md="4" lg="3" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <span
              ><i class="fas fa-cash-register"></i>&nbsp;<b
                >Comandas eliminadas</b
              ></span
            >
            <button
              @click="mtdBack"
              type="button"
              class="btn btn-sm text-white"
              style="background: #e46666"
            >
              <i class="fas fa-hand-point-left"></i> Retroceder
            </button>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                <cSelectForm
                  label="Sede"
                  placeholder="Seleccione una sede"
                  :options="campus"
                  :value.sync="filter.campu"
                />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                <CInput
                  type="date"
                  v-model="filter.initial"
                  :max="hoy"
                  label="Desde"
                />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                <CInput
                  type="date"
                  v-model="filter.end"
                  :max="hoy"
                  label="Hasta"
                />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                <CButton
                  type="button"
                  class="btn btn-sm btn-info w-100"
                  @click="mtdGetSearch"
                >
                  <i class="fas fa-search"></i>&nbsp;Buscar
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="8" lg="9" xl="9">
        <CTableWrapper
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          :items="data"
          small
          fixed
          caption="Lista de comandas eliminadas"
          icon="fas fa-coins"
          :buttonBack="false"
          :size="'md'"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import cSelectForm from "../../../components/shared/inputs/cSelect.vue";
import CTableWrapper from "../../../components/shared/datatable/Table.vue";

const fields = [
  { key: "id", label: "Id", _style: "width:1%" },
  { key: "campu", label: "Sede", _style: "width:5%" },
  { key: "floor", label: "Piso", _style: "width:10%;" },
  { key: "table", label: "Mesa", _style: "width:10%;" },
  { key: "plate", label: "Plato", _style: "width:10%;" },
  { key: "user_reg", label: "Usu. registra", _style: "width:15%;" },
  { key: "created_at", label: "Fecha de creacion", _style: "width:10%;" },
  { key: "user_soli", label: "Usu. solicita", _style: "width:15%;" },
  { key: "user_acep", label: "Usu. acepta", _style: "width:15%;" },
  { key: "deleted_at", label: "Fecha de eliminacion", _style: "width:10%;" },
];

export default {
    name: "c-report-comand",
  components: { cSelectForm, CTableWrapper },
  data() {
    return {
      hoy: null,
      prefix: "/report/command/cancel",
      filter: {
        campu: null,
        initial: null,
        end: null,
      },
      campus: [],
      fields,
      data:[]
    };
  },
  created() {
    moment.locale("es");
    this.hoy = moment().format("YYYY-MM-DD");
    this.filter.initial = this.hoy;
    this.filter.end = this.hoy;
    this.mtdGetData();
    this.mtdGetSearch();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtdGetData: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/report/bead/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.campus = response.data.campu;
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdGetSearch: function () {
      this.post({
        url:
          this.$store.getters.get__url +
          this.prefix,
        token: this.$store.getters.get__token,
        params: this.filter,
      })
        .then((response) => {
          this.data = response.data;
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>